import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  Typography, Box, Chip, Tooltip
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

// Define the features and how to access/format them from the package object.
const featureRows = [
  { feature: 'Monthly Token Limit', key: 'limit_monthly_tokens', format: (val) => val ? val.toLocaleString() : 'Unlimited' },
  { feature: 'Monthly Message Limit', key: 'limit_monthly_messages', format: (val) => val ? val.toLocaleString() : 'Unlimited' },
  { feature: 'Team Member Limit', key: 'limit_team_members', format: (val) => val || 'N/A' },
  { feature: 'API Access', key: 'api_access_enabled', type: 'boolean' },
  { feature: 'Premium Models', key: 'premium_models_enabled', type: 'boolean' },
  { feature: 'Team Collaboration', key: 'team_collaboration_enabled', type: 'boolean' },
  { feature: 'Priority Support', key: 'priority_support', type: 'boolean' },
  { feature: 'Chat History (Days)', key: 'chat_history_retention_days' },
];

const ComparePlansTable = ({ packages }) => {
  if (!packages || packages.length === 0) {
    return null;
  }

  // Ensure packages are sorted by price for consistent column order
  const sortedPackages = [...packages].sort((a, b) => a.price_usd - b.price_usd);

  return (
    <Box sx={{ mt: 8, mb: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Compare Plans
      </Typography>
      <TableContainer component={Paper} elevation={2}>
        <Table sx={{ minWidth: 650 }} aria-label="compare plans table">
          <TableHead>
            <TableRow sx={{ '& .MuiTableCell-head': { fontWeight: 'bold', backgroundColor: 'primary.main', color: 'common.white' } }}>
              <TableCell sx={{width: '30%'}}>Features</TableCell>
              {sortedPackages.map((pkg) => (
                <TableCell key={pkg.id} align="center" sx={{width: `${70 / sortedPackages.length}%`}}>
                  {pkg.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {featureRows.map((row, index) => (
              <TableRow key={row.feature} sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}>
                <TableCell component="th" scope="row">
                  <Typography variant="body1">{row.feature}</Typography>
                </TableCell>
                {sortedPackages.map((pkg) => (
                  <TableCell key={pkg.id} align="center">
                    {row.type === 'boolean' ? (
                      pkg[row.key] ? 
                        <Tooltip title="Included">
                           <CheckCircleIcon sx={{ color: 'success.main' }} />
                        </Tooltip> : 
                        <Tooltip title="Not Included">
                           <CancelIcon sx={{ color: 'error.main' }} />
                        </Tooltip>
                    ) : (
                      <Typography variant="body2">
                        {row.format ? row.format(pkg[row.key]) : (pkg[row.key] || 'N/A')}
                      </Typography>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ComparePlansTable; 